import moment from 'moment';

import { adjustCaretAfterEdit } from '$Utils';

export const onChangeCaretHelper =
    normalizeFunc =>
    ({ event, helpers, meta: { value: valueOld } }) => {
        const { value } = event?.target;
        let valueNew = value;

        if (!valueOld || valueNew.length >= valueOld?.length) {
            valueNew = normalizeFunc(value);
        }
        helpers.setValue(valueNew);
        adjustCaretAfterEdit(event.target);
    };

export const typeaheadHelper = ({ event, helpers }) => {
    const value = event.selectedItem[0];
    helpers.setValue(value);
};

export const multiSelectHelper = ({ event, helpers }) => {
    helpers.setValue(event); 
};

// AntD DatePicker and RangePicker onChange handlers take in a MomentJS object as the first arg,
// which breaks the default Formik handlers.
export const datePickerHelper = ({ callback, event, helpers }) => {
    if (event === null) {
        // by default, clearing the field with the AntD clear button will change the value to null,
        // which is never what we want. convert to empty string.
        helpers.setValue('');
        return;
    }
    // We will probably want to change the default format here to an ISO string if we add a time picker,
    // though for now we can re-format the date in a form's handleSubmit as needed.
    // The format itself could also be an additional arg to FormControl if we want.
    if (Array.isArray(event)) {
        const [startDate, endDate] = event;
        helpers.setValue([
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD')
        ]);
    } else if (moment.isMoment(event)) {
        helpers.setValue(event.format('YYYY-MM-DD'));
    } else {
        helpers.setValue(event);
    }
    if (callback) {
        callback(event.format('YYYY-MM-DD'));
    }
};
